export default {
  draft: 1,
  posted: 2,
  onHold: 3,
  closed: 4,
  archived: 5
};



// WEBPACK FOOTER //
// ./src/constants/vacancy-statuses.js